import { Ref, computed, ref } from "@vue/composition-api";

export const UseFormInput = <T>(
  seed: T,
  validators: Array<(t: T) => boolean>
) => {
  const val: Ref<T> = ref(seed);
  const is_valid = computed(() =>
    validators.every((validate) => validate(val.value))
  );
  return [val, is_valid];
};
